'use client';

import { ReactNode, createContext, useContext } from 'react';

/** `null` = layout auth seed not applied yet (not the same as signed-out Clerk). */
export type AnonAuthHint = boolean | null;
const AnonAuthContext = createContext<AnonAuthHint>(false);
interface AnonAuthProviderProps {
  value: AnonAuthHint;
  children: ReactNode;
}
export function AnonAuthProvider({
  value,
  children
}: AnonAuthProviderProps) {
  return <AnonAuthContext.Provider value={value} data-sentry-element="AnonAuthContext.Provider" data-sentry-component="AnonAuthProvider" data-sentry-source-file="anon-auth-context.tsx">
      {children}
    </AnonAuthContext.Provider>;
}

/**
 * Whether the request is anon/scoped-authed. Returns `null` while the (main)
 * layout stream has not applied `resolveAuth()` yet.
 */
export function useIsAnonAuthed(): AnonAuthHint {
  return useContext(AnonAuthContext);
}

/** True when anon hint is still unresolved on the (main) shell. */
export function useIsAnonAuthPending(): boolean {
  return useIsAnonAuthed() === null;
}